import Vue from 'vue';
import VueI18n from 'vue-i18n';
import config from '../config.js';

import en from './en'
import zh from './zh'
 
Vue.use(VueI18n);
 
const moduleName = config.moduleName;

const messages = {
  en: {
    [moduleName]: en.project,
    route:        en.route,
    httpCode:     en.httpCode
  },
  zh: {
    [moduleName]: zh.project,
    route:        zh.route,
    httpCode:     zh.httpCode
  }
};


export default messages;